import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";

/*
 *
 * Sample usage:
 * <Impression
 *   id='chase-23'
 *   eventType='CC_IMPRESSION_EVENT'
 *   eventData={{
 *     impressionHeader: {
 *       vertical: 'Credit Card',
 *       linkType: 'details_link',
 *       offerVersionId: get(data, config.offerVersionId),
 *       productId: get(data, config.id),
 *       productInstance: 'react-card-template',
 *       productLocation: 'body',
 *       productPosition: position,
 *       productSlug: slug,
 *     }
 *   }}
 * >
 *   <CreditCardUnit/>
 * </Impression>
 *
 */
// Dependencies
import { Component } from 'react';
import PropTypes from 'prop-types'; // Local Dependencies

import withinViewport from '../../shared/in-viewport';
import wrapWithImpressionState from './impression-state';

var Impression = /*#__PURE__*/function (_Component) {
  _inherits(Impression, _Component);

  var _super = _createSuper(Impression);

  function Impression(props) {
    var _this;

    _classCallCheck(this, Impression);

    _this = _super.call(this, props);
    _this.state = {
      impressionId: null
    };
    return _this;
  }

  _createClass(Impression, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var impressionId;

      if (typeof window !== 'undefined' && window.nwa) {
        // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
        impressionId = nwa.generatePageViewId();
      }

      this.setState({
        impressionId: impressionId
      });
      this.checkAndFire();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkAndFire();
    }
  }, {
    key: "checkAndFire",
    value: function checkAndFire() {
      var nwa = typeof window !== 'undefined' && window.nwa; // Attempt to fire tracking when we have a visible component
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      if (this.props.inViewport && !this.props.hasBeenTracked) {
        var eventData = _objectSpread({}, this.props.eventData); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


        var header = this.props.extractImpressionHeader(eventData); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

        header.impressionId = this.state.impressionId; // Delete keys with null/undefined values

        eventData = JSON.parse(JSON.stringify(eventData));

        if (nwa) {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          this.props.impressionReported(eventData); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

          nwa.track(this.props.eventName, eventData);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      return this.props.children || null;
    }
  }]);

  return Impression;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


Impression.displayName = 'Impression'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

Impression.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types -- directive added automatically by Shepherd migration
  eventName: 'IMPRESSION_EVENT',
  extractImpressionHeader: function extractImpressionHeader(eventData) {
    return eventData.impressionHeader;
  }
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

Impression.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types -- directive added automatically by Shepherd migration
  id: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired,
  hasBeenTracked: PropTypes.bool.isRequired,
  inViewport: PropTypes.bool.isRequired,
  impressionReported: PropTypes.func.isRequired,
  extractImpressionHeader: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
  eventData: PropTypes.object
};
export default wrapWithImpressionState(withinViewport()(Impression));